module.exports = function() {
  return new Worker(__webpack_public_path__ + "14f09f2fe0708011b74e.worker.js");
};